import { render, staticRenderFns } from "./newproduct-add.vue?vue&type=template&id=0a20daa2&scoped=true&"
import script from "./newproduct-add.vue?vue&type=script&lang=js&"
export * from "./newproduct-add.vue?vue&type=script&lang=js&"
import style0 from "./newproduct-add.vue?vue&type=style&index=0&id=0a20daa2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20daa2",
  null
  
)

export default component.exports